module.exports = __webpack_public_path__ + "media/images/constancia_assistencia-ac3750e4.jpg";